import { render, staticRenderFns } from "./ImageSetClients.vue?vue&type=template&id=2a3606ef&scoped=true"
import script from "./ImageSetClients.vue?vue&type=script&lang=js"
export * from "./ImageSetClients.vue?vue&type=script&lang=js"
import style0 from "./ImageSetClients.vue?vue&type=style&index=0&id=2a3606ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3606ef",
  null
  
)

export default component.exports